import React from 'react';
import { isRequiredFeatureEnabled } from 'src/components/auth';
import { FileUploadProvider } from 'src/components/molecules';
import { useGetPublicFeaturesQuery } from 'src/graphql';
import * as Types from 'src/types';

export const SubmissionFormProvider = ({
  children,
  organisation,
}: {
  children: React.ReactNode;
  organisation: string;
}) => {
  const { data: publicFeatures } = useGetPublicFeaturesQuery(
    {
      slug: organisation,
    },
    {
      enabled: organisation !== '',
    },
  );

  const isSegmentEnabled = publicFeatures?.getPublicFeatures
    ? isRequiredFeatureEnabled(
        publicFeatures.getPublicFeatures as Types.Feature[],
        Types.FeatureFlag.FRONTEND_SEGMENT_TRACKING,
      )
    : false;

  return (
    <FileUploadProvider
      id="opr-file-upload"
      segmentEnabled={isSegmentEnabled}
      submissionType={Types.SubmissionType.TIME_OF_SUBMISSION}
      platform={Types.Platform.OPR}
    >
      {children}
    </FileUploadProvider>
  );
};
